module.exports = __webpack_public_path__ + "static/media/how_da.fd783558.vtt";